import { Nullable } from '../../types';
import { isNullish } from '../validation';

const isFiniteNumber = (value: Nullable<number>): value is number =>
  !isNullish(value) && !Number.isNaN(value) && Number.isFinite(value);

export default isFiniteNumber;
